import { useEffect } from "react";
import META from "@/seo/meta.json";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    const [, key, name] = selector.match(/\[(.+?)="(.+?)"\]/) || [];
    if (key) el.setAttribute(key, name);
    if (selector.startsWith("link")) el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

/** Aligne le <head> sur la route courante lors d'une navigation interne. */
export default function useSeo(route) {
  useEffect(() => {
    const p = META.pages[route];
    if (!p) return;
    const url = `${META.site.origin}${route}`;
    document.title = p.title;
    setMeta('meta[name="description"]', "content", p.description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", p.title);
    setMeta('meta[property="og:description"]', "content", p.description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", p.title);
    setMeta('meta[name="twitter:description"]', "content", p.description);
  }, [route]);
}
